<template>
	<GmapMap :options="options"
				ref="mapRef"
				:center="center"
				@zoom_changed="zoom = $event"
				:zoom="zoom"
				map-type-id="roadmap"
				style="width: 100%; height: 100%"
				@click="infoWinOpen=false"
				>
		<GmapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
		</GmapInfoWindow>
		<GmapMarker :key="index"
					v-for="(m, index) in markers"
					:position="m.position"
					:icon="m.icon"
					:clickable="true"
					@click="toggleInfoWindow(m,index)"
					@mouseover="markerMouseEnter(m)"
					@mouseout="markerMouseLeave(m)"
					:draggable="false" />
	</GmapMap>
</template>

<script>
	import { gmapApi } from 'vue2-google-maps';
	import { mapState } from 'vuex';
	import * as CONST from '../../utils/constants';
	import DateFormatService from '../../services/date-format.service';

	export default {
		data: function () {
			return {
				center: { lat: 10.0, lng: 10.0 },
				googleMap: null,
				zoom: 10,
				defaultIcon: {url: '/content/images/map-marker.png'},
				hoverIcon:  {url: '/content/images/map-marker.png'},
				options: {
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					disableDefaultUi: false
				},
				infoWindowPos: null,
				infoWinOpen: false,
				currentMidx: null,
				infoOptions: {
					content: '',
					//optional: offset infowindow so it visually sits nicely on top of our marker
					pixelOffset: {
						width: 0,
						height: -35
					}
				},
				markers: []
			}
		},
		computed: {
			...mapState({
				listing: state => state.listing.listing,
			}),
		},
		watch: {
			listing: {
				handler: function (newProp, oldProp) {
					this.setMarkers(newProp);
				},
				deep: true,
				immediate: true
			},
		},
		mounted: function () {
			this.$refs.mapRef.$mapPromise.then(() => {
				this.setMarkers(this.listing);
			});
		},
		methods: {
			formatDateRange(start, end) {
				return DateFormatService.formatDateRange(start, end);
			},
			toggleInfoWindow: function (marker, idx) {
				this.infoWindowPos = marker.position;
				this.infoOptions.content = marker.infoText;

				//check if its the same marker that was selected if yes toggle
				if (this.currentMidx == idx) {
					this.infoWinOpen = !this.infoWinOpen;
				}
				//if different marker set infowindow to open and reset current marker index
				else {
					this.infoWinOpen = true;
					this.currentMidx = idx;

				}
			},
			setMarkers(listing) {
				this.markers = [];
				if (window.google !== undefined) {
					this.defaultIcon = {
						url: '/content/images/map-marker.png',
						size: new google.maps.Size(42, 58),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(10, 29),
						scaledSize: new google.maps.Size(21, 29)
					};
					this.hoverIcon = {
						url: '/content/images/map-marker.png',
						size: new google.maps.Size(42, 58),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(13, 36),
						scaledSize: new google.maps.Size(26, 36)
					};
					let b = new window.google.maps.LatLngBounds();

					if (listing.length >= 1) {
						listing.forEach((item) => {
							if (item.Geolocation !== null) {
								let marker = {
									position: {
										lat: item.Geolocation.Latitude,
										lng: item.Geolocation.Longitude
									},
									icon: this.defaultIcon,
									title: item.Title,
									infoText: `
									<h3>${item.Title}</h3>
									<p class='infobox-date'>${this.formatDateRange(item.StartDate, item.EndDate)}</p>
									<p class='infobox-summary'>${item.Summary}</p>
									<p class='align-right'><a class='cta-link' href='${item.Url}'>Learn More</a></p>
									`
								}

								this.markers.push(marker);
								if (listing.length > 1) {
									b.extend({
										lat: item.Geolocation.Latitude,
										lng: item.Geolocation.Longitude
									});
								}
								else if (this.markers.length === 1) {
									b.extend({
										lat: item.Geolocation.Latitude,
										lng: item.Geolocation.Longitude
									});

									this.center = { lat: listing[0].Geolocation.Latitude, lng: listing[0].Geolocation.Longitude };
								}
							}
						});

						if (this.markers.length >= 1) {
							this.$refs.mapRef.fitBounds(b);

							if (this.markers.length === 1) {
								setTimeout(() => this.zoom = 10, 500);
							}
						}
					}
					else {
						b.extend({
							lat: 41.909541,
							lng: -124.175651
						});

						b.extend({
							lat: 44.835672,
							lng: -67.072421
						});

						this.$refs.mapRef.fitBounds(b);
					}
				}
			},
			markerMouseEnter(marker) {
				marker.icon = this.hoverIcon;
			},
			markerMouseLeave(marker) {
				marker.icon = this.defaultIcon;
			}
        },
    }
</script>